import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_2 = { style: {"margin-right":"auto"} }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { style: {"text-align":"center"} }, [
  /*#__PURE__*/_createElementVNode("h1", null, "支付信息列表")
], -1)
const _hoisted_4 = { style: {"padding":"20px"} }
const _hoisted_5 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_6 = { style: {"margin-right":"auto"} }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { style: {"text-align":"center"} }, [
  /*#__PURE__*/_createElementVNode("h1", null, "支付渠道列表")
], -1)
const _hoisted_8 = { style: {"padding":"20px"} }

import { ref, reactive } from 'vue';
import { layer } from '@layui/layui-vue';

import { addPayInfo,allPayInfo,payInfoState,delPayInfo,addPaymentChannel,allPaymentChannel,paymentChannelState,delPaymentChannel } from '../../api'



export default /*#__PURE__*/_defineComponent({
  __name: 'payConfig',
  setup(__props) {

const loading = ref(false); 
    const selectedKeys:any = ref([]);
    const payIndataSource = ref([])

    const payInfoPage = reactive({ current: 1, limit: 10, total: 0 });

    const columns = ref([ 
      { title:"序号",key:"id",align:"center" },
      { title:"金额", key:"amount" ,align:"center" }, 
      { title:"天数", key:"days" ,align:"center" },   
      { title:"说明", key:"caption" ,align:"center" },   
      { title:"状态", width: "80px", key:"state" ,align:"center",customSlot:'status'},
      { title:"时间", width: "120px", key:"addTime" ,align:"center"},
      { title:"操作", width: "60px", customSlot:"operator", key:"operator", fixed: "right", ignoreExport: true }
    ]);

    const  paymentChannel= ref([ 
    { title:"状态", width: "80px", key:"state" ,align:"center",customSlot:'status'},  
      { title:"平台名称", key:"platformName" ,align:"center" },  
      { title:"支付接口", key:"payApi" ,align:"center" }, 
      { title:"api网关", key:"apiUrl" ,align:"center" }, 
      { title:"商户id", key:"merchantId" ,align:"center" }, 
      { title:"支付宝编码", key:"payCode" ,align:"center" },   
      { title:"微信编码", key:"weChatCode" ,align:"center" },   
      { title:"支付回调地址", key:"callbackUrl" ,align:"center" },   
      { title:"充值成功地址", key:"successPageUrl" ,align:"center" },   
      { title:"商户key", key:"merchantKey" ,align:"center" },  
      { title:"时间", width: "120px", key:"addTime" ,align:"center"},
      { title:"操作",  customSlot:"operator", key:"operator", fixed: "right", ignoreExport: true }
     
    ]);

   const  getAllPayInfo=()=>{

    var data = { "page": payInfoPage.current, "limit": payInfoPage.limit};
    allPayInfo(JSON.stringify(data)).then((res: any) => {
    loading.value = false;
    if (res != "" && res.code == 0) {
        payIndataSource.value = []; 
      payIndataSource.value = res.data;
      payInfoPage.total = res.count;
    } else {
        payIndataSource.value = [];
        payInfoPage.total = 0;
    }
  })

   }

   getAllPayInfo();  

    const payInfoChange = (page:any) => {
        getAllPayInfo(); 
    }

    const sortChange = (key:any, sort:any) => {
      layer.msg(`字段${key} - 排序${sort}, 你可以利用 sort-change 实现服务端排序`)
    }



    const payInfoChangeStatus = (isChecked:any, row:any) => {
         var data={"id":row.id,"key":row.state};
        payInfoState(JSON.stringify(data)).then((res: any) => {
        if (res != "" && res.code == 0) {
          layer.msg("操作成功", { time: 1000, icon: 1 })
         getAllPayInfo();  
        }
      })

 
    }

    const payInfoRemove = (row:any) => {
        var data={"id":row.id,"key":row.state};
        delPayInfo(JSON.stringify(data)).then((res: any) => {
        if (res != "" && res.code == 0) {
            layer.msg("删除成功", { time: 1000, icon: 1 })
             getAllPayInfo();  
        }
      })
    }

  






   const isPayInfo=ref(false) 
//添加支付信息
  
  const  addPayInfos=()=>{ 
    isPayInfo.value = !isPayInfo.value; 
  }


  const payInfo = reactive({
    amount: "",
    days:"",
    caption:""
})


const  payInfoBtn= ref([
    {
        text: "确认",
        callback: () => { 
       
            addPayInfo(JSON.stringify(payInfo)).then((res: any) => {
                      if (res != "" && res.code == 0) {
                        getAllPayInfo(); 
                        layer.msg("操作成功", { time: 1000, icon: 1 })
                        isPayInfo.value = !isPayInfo.value; 
                      }
                    })

        }
    },
    {
        text: "取消",
        callback: () => {
            isPayInfo.value = !isPayInfo.value; 
        }
    }
])


//支付渠道
const  isPaymentChannelInfo=ref(false) ;
const  addPaymentChannelInfo=()=>{ 
    isPaymentChannelInfo.value = !isPaymentChannelInfo.value; 
  }


  const paymentChannelInfo = reactive({
    id:0,
    apiUrl: "",
    platform:0,
    platformName:"",
    merchantId:"",
    payCode:"",
    weChatCode:"",
    payApi:"",
    callbackUrl:"",
    successPageUrl:"",
    merchantKey:"", 
    weChatHandlingFee:"", 
     payHandlingFee:"", 
     mark:0,
})
  


const  paymentChannelEdit=(row:any)=>{ 
        
        paymentChannelInfo.id=row.id;
        paymentChannelInfo.apiUrl=row.apiUrl;
        paymentChannelInfo.platform=row.platform;
        paymentChannelInfo.platformName=row.platformName;
        paymentChannelInfo.merchantId=row.merchantId;
        paymentChannelInfo.payCode=row.payCode;
        paymentChannelInfo.weChatCode=row.weChatCode;
        paymentChannelInfo.payApi=row.payApi;
        paymentChannelInfo.callbackUrl=row.callbackUrl;
        paymentChannelInfo.successPageUrl=row.successPageUrl;
        paymentChannelInfo.merchantKey=row.merchantKey; 
        paymentChannelInfo.weChatHandlingFee=row.weChatHandlingFee; 
        paymentChannelInfo.payHandlingFee=row.payHandlingFee; 
        paymentChannelInfo.mark=row.mark; 
        
       isPaymentChannelInfo.value = !isPaymentChannelInfo.value; 
     }
   

  const  paymentChannelBtn= ref([
    {
        text: "确认",
        callback: () => { 
       
            addPaymentChannel(JSON.stringify(paymentChannelInfo)).then((res: any) => {
                      if (res != "" && res.code == 0) {
                        getAllPaymentChannel();
                        layer.msg("操作成功", { time: 1000, icon: 1 })
                        isPaymentChannelInfo.value = !isPaymentChannelInfo.value; 
                      }
                    })

            
        }
    },
    {
        text: "取消",
        callback: () => {
            isPaymentChannelInfo.value = !isPaymentChannelInfo.value; 
        }
    }
])

//显示信息


const paymentChannelPage = reactive({ current: 1, limit: 10, total: 0 });

 const paymentChannelPdataSource=ref([])


const  getAllPaymentChannel=()=>{

    var data = { "page": paymentChannelPage.current, "limit": paymentChannelPage.limit};
    allPaymentChannel(JSON.stringify(data)).then((res: any) => {
    loading.value = false;
    if (res != "" && res.code == 0) {
        paymentChannelPdataSource.value = []; 
        paymentChannelPdataSource.value = res.data;
      payInfoPage.total = res.count;
    } else {
        paymentChannelPdataSource.value = [];
        paymentChannelPage.total = 0;
    }
  })
}

getAllPaymentChannel();
const  paymentChannelChange=()=>{

    getAllPaymentChannel();
}


const paymentChannelChangeStatus = ( row:any) => {
         var data={"id":row.id,"key":row.state};
         paymentChannelState(JSON.stringify(data)).then((res: any) => {
        if (res != "" && res.code == 0) {
            getAllPaymentChannel();
        }
      })

 
    }

    const paymentChannelRemove = (row:any) => {
        var data={"id":row.id,"key":row.state};
        delPaymentChannel(JSON.stringify(data)).then((res: any) => {
        if (res != "" && res.code == 0) {
            layer.msg("删除成功", { time: 1000, icon: 1 })
            getAllPaymentChannel();
        }
      })
    }




return (_ctx: any,_cache: any) => {
  const _component_lay_button = _resolveComponent("lay-button")!
  const _component_lay_switch = _resolveComponent("lay-switch")!
  const _component_lay_table = _resolveComponent("lay-table")!
  const _component_lay_panel = _resolveComponent("lay-panel")!
  const _component_lay_input = _resolveComponent("lay-input")!
  const _component_lay_form_item = _resolveComponent("lay-form-item")!
  const _component_lay_form = _resolveComponent("lay-form")!
  const _component_lay_layer = _resolveComponent("lay-layer")!
  const _component_lay_col = _resolveComponent("lay-col")!
  const _component_lay_row = _resolveComponent("lay-row")!

  return (_openBlock(), _createBlock(_component_lay_row, { space: "10" }, {
    default: _withCtx(() => [
      _createVNode(_component_lay_col, { md: "8" }, {
        default: _withCtx(() => [
          _createVNode(_component_lay_panel, { style: {"padding":"10px"} }, {
            default: _withCtx(() => [
              _createVNode(_component_lay_table, {
                page: payInfoPage,
                height: '100%',
                columns: columns.value,
                loading: loading.value,
                "default-toolbar": false,
                "data-source": payIndataSource.value,
                "selected-keys": selectedKeys.value,
                "onUpdate:selectedKeys": _cache[0] || (_cache[0] = ($event: any) => ((selectedKeys).value = $event)),
                onChange: payInfoChange,
                onSortChange: sortChange
              }, {
                toolbar: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                      _createVNode(_component_lay_button, {
                        type: "primary",
                        onClick: addPayInfos
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("添加")
                        ]),
                        _: 1
                      })
                    ]),
                    _hoisted_3
                  ])
                ]),
                operator: _withCtx(({ row }) => [
                  _createVNode(_component_lay_button, {
                    size: "xs",
                    onClick: ($event: any) => (payInfoRemove(row))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("删除")
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                status: _withCtx(({ row }) => [
                  _createVNode(_component_lay_switch, {
                    "model-value": row.state == 0 ? true : false,
                    onChange: ($event: any) => (payInfoChangeStatus($event , row))
                  }, null, 8, ["model-value", "onChange"])
                ]),
                _: 1
              }, 8, ["page", "columns", "loading", "data-source", "selected-keys"])
            ]),
            _: 1
          }),
          _createVNode(_component_lay_layer, {
            modelValue: isPayInfo.value,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((isPayInfo).value = $event)),
            shade: false,
            area: ['350px', '300px'],
            btn: payInfoBtn.value,
            title: "添加支付信息"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_lay_form, { model: payInfo }, {
                  default: _withCtx(() => [
                    _createVNode(_component_lay_form_item, {
                      label: "金额",
                      prop: "amount"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_lay_input, {
                          modelValue: payInfo.amount,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((payInfo.amount) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_lay_form_item, {
                      label: "天数",
                      prop: "days"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_lay_input, {
                          modelValue: payInfo.days,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((payInfo.days) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_lay_form_item, {
                      label: "说明",
                      prop: "days"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_lay_input, {
                          modelValue: payInfo.caption,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((payInfo.caption) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model"])
              ])
            ]),
            _: 1
          }, 8, ["modelValue", "btn"])
        ]),
        _: 1
      }),
      _createVNode(_component_lay_col, { md: "16" }, {
        default: _withCtx(() => [
          _createVNode(_component_lay_panel, { style: {"padding":"10px"} }, {
            default: _withCtx(() => [
              _createVNode(_component_lay_table, {
                page: paymentChannelPage,
                height: '100%',
                columns: paymentChannel.value,
                loading: loading.value,
                "default-toolbar": false,
                "data-source": paymentChannelPdataSource.value,
                "selected-keys": selectedKeys.value,
                "onUpdate:selectedKeys": _cache[5] || (_cache[5] = ($event: any) => ((selectedKeys).value = $event)),
                onChange: paymentChannelChange,
                onSortChange: sortChange
              }, {
                toolbar: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_lay_button, {
                        type: "primary",
                        onClick: addPaymentChannelInfo
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("添加")
                        ]),
                        _: 1
                      })
                    ]),
                    _hoisted_7
                  ])
                ]),
                operator: _withCtx(({ row }) => [
                  _createVNode(_component_lay_button, {
                    size: "xs",
                    onClick: ($event: any) => (paymentChannelEdit(row))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("编辑")
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_lay_button, {
                    size: "xs",
                    onClick: ($event: any) => (paymentChannelRemove(row))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("删除")
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                status: _withCtx(({ row }) => [
                  _createVNode(_component_lay_switch, {
                    "model-value": row.state == 0 ? true : false,
                    onChange: ($event: any) => (paymentChannelChangeStatus(row))
                  }, null, 8, ["model-value", "onChange"])
                ]),
                _: 1
              }, 8, ["page", "columns", "loading", "data-source", "selected-keys"])
            ]),
            _: 1
          }),
          _createVNode(_component_lay_layer, {
            modelValue: isPaymentChannelInfo.value,
            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((isPaymentChannelInfo).value = $event)),
            shade: false,
            area: ['400px', '620px'],
            btn: paymentChannelBtn.value,
            title: "添加支付渠道"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_lay_form, { model: paymentChannelInfo }, {
                  default: _withCtx(() => [
                    _createVNode(_component_lay_form_item, {
                      label: "api网关",
                      prop: "apiUrl"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_lay_input, {
                          modelValue: paymentChannelInfo.apiUrl,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((paymentChannelInfo.apiUrl) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_lay_form_item, {
                      label: "平台名称",
                      prop: "platformName"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_lay_input, {
                          modelValue: paymentChannelInfo.platformName,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((paymentChannelInfo.platformName) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_lay_form_item, {
                      label: "支付接口",
                      prop: "payApi"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_lay_input, {
                          modelValue: paymentChannelInfo.payApi,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((paymentChannelInfo.payApi) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_lay_form_item, {
                      label: "调用方法",
                      prop: "platform"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_lay_input, {
                          modelValue: paymentChannelInfo.platform,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((paymentChannelInfo.platform) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_lay_form_item, {
                      label: "商户id",
                      prop: "merchantId"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_lay_input, {
                          modelValue: paymentChannelInfo.merchantId,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((paymentChannelInfo.merchantId) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_lay_form_item, {
                      label: "支付宝编码",
                      prop: "payCode"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_lay_input, {
                          modelValue: paymentChannelInfo.payCode,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((paymentChannelInfo.payCode) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_lay_form_item, {
                      label: "微信编码",
                      prop: "weChatCode"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_lay_input, {
                          modelValue: paymentChannelInfo.weChatCode,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((paymentChannelInfo.weChatCode) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_lay_form_item, {
                      label: "微信手续费",
                      prop: "weChatHandlingFee"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_lay_input, {
                          modelValue: paymentChannelInfo.weChatHandlingFee,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((paymentChannelInfo.weChatHandlingFee) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_lay_form_item, {
                      label: "支付宝手续费",
                      prop: "payHandlingFee"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_lay_input, {
                          modelValue: paymentChannelInfo.payHandlingFee,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((paymentChannelInfo.payHandlingFee) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_lay_form_item, {
                      label: "支付回调地址",
                      prop: "callbackUrl"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_lay_input, {
                          modelValue: paymentChannelInfo.callbackUrl,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((paymentChannelInfo.callbackUrl) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_lay_form_item, {
                      label: "充值成功地址",
                      prop: "successPageUrl"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_lay_input, {
                          modelValue: paymentChannelInfo.successPageUrl,
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((paymentChannelInfo.successPageUrl) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_lay_form_item, {
                      label: "商户key",
                      prop: "merchantKey"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_lay_input, {
                          modelValue: paymentChannelInfo.merchantKey,
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((paymentChannelInfo.merchantKey) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(">")
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_lay_form_item, {
                      label: "平台回调类型",
                      prop: "mark"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_lay_input, {
                          modelValue: paymentChannelInfo.mark,
                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((paymentChannelInfo.mark) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(">")
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model"])
              ])
            ]),
            _: 1
          }, 8, ["modelValue", "btn"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})